// extracted by mini-css-extract-plugin
export default {"topBar":"TopBar_topBar__nE7u5","logo":"TopBar_logo__T6q1l","title":"TopBar_title__Wn9sm","profile":"TopBar_profile__GT+P3"};